import { createFileRoute } from "@tanstack/react-router";
import { warmSymbolShellFromListRoute } from "~/features/symbol/routing/warm-symbol-shell";
import { createSocialHeadMeta } from "~/lib/social-head";
import { EXPLORE_SOCIAL_METADATA } from "~/lib/social-metadata";

export const Route = createFileRoute("/_app/explore")({
  head: () => ({
    meta: createSocialHeadMeta(EXPLORE_SOCIAL_METADATA),
  }),
  loader: ({ context, preload }) => {
    void import("~/features/explore/explore-route").then(
      ({ preloadExploreRoute }) => {
        void preloadExploreRoute(context);
      },
    );
    warmSymbolShellFromListRoute(preload);
  },
});
